<template>
    <div class="layout">
        <div class="layout__header">
            <div class="layout__title">
                <h3>Edición de contenedor {{ number }}</h3>
            </div>
        </div>
        <div class="row">
            <div class="col-xs-12 col-md-6">
                <div class="form-field">
                    <p>
                        <label for="aprobado_b">
                            <input @change="changeFechaAprobacion" :disabled="!permiteAprobarCaja" type="checkbox" name="aprobado_b" id="aprobado_b" v-model="form.aprobado_b"> <span>Aprobación (Caja)</span>
                        </label>
                    </p>
                </div>
            </div>
            <div class="col-xs-12 col-md-6">
                <div class="form-field">
                    <div class="datepicker-field datepicker-field--stretch">
                        <date-picker :disabled="!permiteAprobarCaja || !form.aprobado_b" type="date" format="dd-MM-yyyy" id="date_a_b" v-model="form.date_a_b" lang="es"></date-picker>
                        <label>Fecha de aprobación (Caja)</label>
                        <span v-if="errores.date_a_b" class="helper-text text-danger" slot="helper">
                            <strong>{{ errores.date_a_b[0] }}</strong>
                        </span>
                    </div>
                </div>
            </div>
            <div v-show="esMaquina" class="col-xs-12 col-md-6">
                <div class="form-field">
                    <p>
                        <label for="aprobado_m">
                            <input @change="changeAprobacionMaquina" :disabled="!permiteAprobarMaquina" type="checkbox" name="aprobado_m" id="aprobado_m" v-model="form.aprobado_m"> <span>Aprobación (Máquina)</span>
                        </label>
                    </p>
                </div>
            </div>
            <div v-show="esMaquina" class="col-xs-12 col-md-6">
                <div class="form-field">
                    <div class="datepicker-field datepicker-field--stretch">
                        <date-picker  :disabled="!permiteAprobarMaquina || !form.aprobado_m" type="date" format="dd-MM-yyyy" id="date_a_m" v-model="form.date_a_m" lang="es"></date-picker>
                        <label>Fecha de aprobación (Máquina)</label>
                        <span v-if="errores.date_a_m" class="helper-text text-danger" slot="helper">
                            <strong>{{ errores.date_a_m[0] }}</strong>
                        </span>
                    </div>
                </div>
            </div>
            <div class="col-xs-12 col-md-6">
                <div class="form-field">
                    <p>
                        <label for="invoiced_box">
                            <input @change="changeFacturacionCaja" :disabled="!permiteFacturarCaja" type="checkbox" name="invoiced_box" id="invoiced_box" v-model="form.invoiced_box"> <span>Facturación (Caja)</span>
                        </label>
                    </p>
                </div>
            </div>
            <div class="col-xs-12 col-md-6">
                <div class="form-field">
                    <div class="datepicker-field datepicker-field--stretch">
                        <date-picker :disabled="!permiteFacturarCaja || !form.invoiced_box" type="date" format="dd-MM-yyyy" id="date_i_b" v-model="form.date_i_b" lang="es"></date-picker>
                        <label>Fecha de facturación (Caja)</label>
                        <span v-if="errores.date_i_b" class="helper-text text-danger" slot="helper">
                            <strong>{{ errores.date_i_b[0] }}</strong>
                        </span>
                    </div>
                </div>
            </div>
            <div v-show="esMaquina" class="col-xs-12 col-md-6">
                <div class="form-field">
                    <p>
                        <label for="invoiced_machine">
                            <input @change="changeFechaFacturacionM" :disabled="!permiteFacturarMaquina" type="checkbox" name="invoiced_machine" id="invoiced_machine" v-model="form.invoiced_machine"> <span>Facturación (Máquina)</span>
                        </label>
                    </p>
                </div>
            </div>
            <div v-show="esMaquina" class="col-xs-12 col-md-6">
                <div class="form-field">
                    <div class="datepicker-field datepicker-field--stretch">
                        <date-picker :disabled="!permiteFacturarMaquina || !form.invoiced_machine" type="date" format="dd-MM-yyyy" id="date_i_m" v-model="form.date_i_m" lang="es"></date-picker>
                        <label>Fecha de facturación (Máquina)</label>
                        <span v-if="errores.date_i_m" class="helper-text text-danger" slot="helper">
                            <strong>{{ errores.date_i_m[0] }}</strong>
                        </span>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal-buttons">
            <button :disabled="!permiteAprobarCaja && !permiteAprobarMaquina && !permiteFacturarCaja && !permiteFacturarMaquina" class="btn-success" type="button" @click="aceptar">
                <i class="fa fa-check"></i><span>Aceptar</span>
            </button>
            <button class="btn-danger btn--text" type="button" @click="$emit('cancelar')">
                <i class="fa fa-ban"></i><span>Cancelar</span>
            </button>
        </div>
    </div>
</template>

<script>
export default {
    props : {
        number : {
            type : String,
            required : true
        },
        esMaquina : {
            type : Boolean,
            required : true
        },
        value : {
            type : Object,
            required : false,
            default : function () {
                return {
                    aprobado_m : false,
                    aprobado_b : false,
                    invoiced_box : false,
                    invoiced_machine : false,
                    date_i_b : moment(new Date()).format('YYYY-MM-DD'),
                    date_i_m : moment(new Date()).format('YYYY-MM-DD'),
                    date_a_b : moment(new Date()).format('YYYY-MM-DD'),
                    date_a_m : moment(new Date()).format('YYYY-MM-DD'),
                    secuencia : 0,
                    _method : 'PUT'
                };
            }
        }
    },
    data : function () {
        return {
            permiteAprobarCaja : !this.value.aprobado_b,
            permiteAprobarMaquina : !this.value.aprobado_m && this.esMaquina,
            permiteFacturarCaja : !this.value.invoiced_box,
            permiteFacturarMaquina : !this.value.invoiced_machine && this.esMaquina,
            form : this.value,
            errores : {}
        };
    },
    methods : {
        changeAprobacionMaquina : function () {
            if (this.form.aprobado_m)
                this.form.date_a_m = moment(new Date()).format('YYYY-MM-DD');
            else 
                this.form.date_a_m = '';
        },
        changeFacturacionCaja : function () {
            if (this.form.invoiced_box)
                this.form.date_i_b = moment(new Date()).format('YYYY-MM-DD');
            else 
                this.form.date_i_b = '';
        },
        changeFechaFacturacionM : function () {
            if (this.form.invoiced_machine)
                this.form.date_i_m = moment(new Date()).format('YYYY-MM-DD');
            else 
                this.form.date_i_m = '';
        },     
        changeFechaAprobacion : function () {
            if (this.form.aprobado_b)
                this.form.date_a_b = moment(new Date()).format('YYYY-MM-DD');
            else 
                this.form.date_a_b = '';
        },
        aceptar : function () {
            let that = this;
            axios.post(url + '/historico/' + this.number, this.form).then(function (response) {
                swal('Los datos han sido actualizados.', 'Realizado', 'success');
                that.$emit('aceptar');
            }).catch(function (error) {
                if (error !== undefined && error !== null) {
                    let response = error.response;
                    if (response !== undefined && response !== null) {
                        that.errores = response.errors;
                        swal('Hay errores en el formulario.', 'Aviso', 'warning');
                        return;
                    }
                }
                swal('Hubo un error, intente nuevamente.', 'Error', 'error');
            });
        }
    }
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/forms/EdicionHistorico.vue